const initialState = {
  newCmpForm: false,
  communityBasedProvider: '',
  counselingStaffAssigned: '',
  oracCmpDt1: '',
  orasCmpDt2: '',
  orasCmpDt3: '',
  orasTgtDt1: '',
  orasTgtDt2: '',
  orasTgtDt3: '',
  revisionGoals1: null,
  revisionGoals2: null,
  revisionObjectives1: null,
  revisionObjectives2: null,
  revisionTargetDate1: '',
  revisionTargetDate2: '',
  revisionCompletedOn1: '',
  revisionCompletedOn2: '',
  dischargeGoals1: null,
  dischargeGoals2: null,
  dischargeObjectives1: null,
  dischargeObjectives2: null,
  dischargeTargetDate1: '',
  dischargeTargetDate2: '',
  comments: null,
  createdBy: '',
  createdDate: '',
  editBy: '',
  editDate: '',
  participant1: '',
  participant2: '',
  participant3: '',
  participant4: '',
  participant5: '',
  participant6: '',
  css1: '',
  css2: '',
  css3: '',
  css4: '',
  css5: '',
  css6: '',
  scss1: '',
  scss2: '',
  scss3: '',
  scss4: '',
  scss5: '',
  scss6: '',
  rvwDate1: '',
  rvwDate2: '',
  rvwDate3: '',
  rvwDate4: '',
  rvwDate5: '',
  rvwDate6: '',
};

export default initialState;
